import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'

const ACCEPT = {
  'application/pdf': [ '.pdf' ],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [ '.docx' ],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': [ '.pptx' ],
  'image/png':  [ '.png' ],
  'image/jpeg': [ '.jpg', '.jpeg' ],
  'text/plain': [ '.txt' ],
  'text/markdown': [ '.md' ],
}

const MAX_SIZE = 50 * 1024 * 1024 // 50 MB

export default function UploadZone({ onFilesAccepted, disabled }) {
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length > 0) onFilesAccepted(acceptedFiles)
    },
    [onFilesAccepted]
  )

  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    onDrop,
    accept: ACCEPT,
    maxSize: MAX_SIZE,
    disabled,
    multiple: true,
  })

  const baseClass =
    'flex flex-col items-center justify-center rounded-2xl border-2 border-dashed bg-white px-8 py-16 text-center transition'
  const stateClass = disabled
    ? 'border-slate-200 opacity-50 cursor-not-allowed'
    : isDragReject
      ? 'border-rose-400 bg-rose-50'
      : isDragActive
        ? 'border-accent-500 bg-accent-50'
        : 'border-slate-300 hover:border-accent-400 cursor-pointer'

  return (
    <div {...getRootProps({ className: `${baseClass} ${stateClass}` })}>
      <input {...getInputProps()} />
      <div className="text-4xl mb-2" aria-hidden="true">📥</div>
      <p className="text-sm font-medium text-slate-900">
        {disabled
          ? 'Select an initiative first'
          : isDragActive
            ? 'Drop to upload'
            : 'Drag & drop files here, or click to browse'}
      </p>
      <p className="mt-1 text-xs text-slate-500">
        PDF · DOCX · PPTX · PNG · JPG · TXT · MD · up to 50MB
      </p>
    </div>
  )
}
